import { render, staticRenderFns } from "./DeliveryLoading.vue?vue&type=template&id=ad271fde&scoped=true"
import script from "./DeliveryLoading.vue?vue&type=script&lang=js"
export * from "./DeliveryLoading.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad271fde",
  null
  
)

export default component.exports